"use client";

import { useRef, useState } from "react";
import { createPortal } from "react-dom";
import Image from "next/image";
import { Button } from "../../shadcn/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../shadcn/tooltip";
import { FloatingMenuItem } from "@/app/lib/features/floatingContent/floatingContent.types";
import TozyDialog from "./TozyDialog";
import { trackGeneric } from "@/app/lib/tracking/interactions";

interface AiButtonProps {
  item: FloatingMenuItem;
}

const AiButton = ({ item }: AiButtonProps) => {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            ref={triggerRef}
            type="button"
            onClick={() => { if (!open) trackGeneric("tozy_chat"); setOpen((v) => !v); }}
            className="w-10 sm:w-11 lg:w-12 h-10 sm:h-11 lg:h-12 rounded-xl p-0 shadow-md transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5"
            // Button'a class ile bg geçmek bu projede çalışmıyor (bkz. shadcn
            // override notu), o yüzden style prop. Ham hex yerine token: marka
            // rengi değişirse burası da kendiliğinden takip etsin.
            // className'deki `bg-black hover:bg-neutral-800` kaldırıldı — inline
            // style zaten onları eziyordu, sadece okuyanı yanıltıyorlardı.
            style={{ backgroundColor: "var(--color-brand)" }}
          >
            <Image
              src={item.icon}
              alt={item.title}
              width={28}
              height={28}
              className="object-contain"
            />
          </Button>
        </TooltipTrigger>
        {item.placeholder && !open && (
          <TooltipContent side="left">
            <p>{item.placeholder}</p>
          </TooltipContent>
        )}
      </Tooltip>

      {open && createPortal(
        <TozyDialog
          triggerRef={triggerRef}
          icon={item.icon}
          onClose={() => setOpen(false)}
        />,
        document.body
      )}
    </>
  );
};

export default AiButton;